import { Component } from '@angular/core';

@Component({
  template: `
    @if (!showBlank()) {
      <div class="value">
        {{ getDisplayValue() }}
      </div>
    }
    @if (showBlank()) {
      <glxy-blank-value />
    }
  `,
  standalone: false,
})
export class BooleanRendererComponent {
  value: boolean | undefined;

  showBlank(): boolean {
    return !this.value === undefined;
  }

  getDisplayValue(): string {
    if (this.value === undefined) {
      return '-';
    }
    if (this.value) {
      return 'True';
    }
    return 'False';
  }
}
